import { useEffect, useState } from "react";
import { http } from "./api";

let request;
export const useNavigation = () => {
  const [data, setData] = useState(null);
  useEffect(() => {
    let active = true;
    if (!request) request = http.get("/navigation").then(r => r.data).catch(() => { request = null; return null; });
    request.then(value => { if (active) setData(value); });
    return () => { active = false; };
  }, []);
  return data;
};

export const findNavigation = (nodes, id, parents = []) => {
  for (const node of nodes || []) {
    if (node.id === id) return { node, parents };
    const found = findNavigation(node.children, id, [...parents, node]);
    if (found) return found;
  }
  return null;
};
